<template>
  <main class="main" role="main">
    <div class="main_con">
      <div class="counsel_top_wrap">
        <div class="counsel_top">
          <div class="counsel_top_img">
            <img src="@/assets/front/images/new/i_c_document_g.svg" alt="" />
          </div>
          <router-link
            :to="{ name: 'Estimation.Manage' }"
            tag="button"
            class="counsel_top_txt"
            >내 요청서 보기</router-link
          >
        </div>
      </div>
      <div class="n_counsel_start">
        <div class="way_buy">
          <h1 class="w_ttl">퍼스로 휴대폰 잘 사는 방법!</h1>
          <div class="w_cont">
            <ul>
              <li>
                <img src="@/assets/front/images/manual/img_way_01.png" />
                <div class="step"><p>STEP 1</p></div>
                <div class="txt">
                  <p>
                    요청서를 작성하여 구매를 희망하는 휴대폰을 등록해주세요.<br />
                    <span>(홈 화면 '휴대폰 상담 시작하기' 이용)</span>
                  </p>
                </div>
              </li>
              <li>
                <img src="@/assets/front/images/manual/img_way_02.png" />
                <div class="step"><p>STEP 2</p></div>
                <div class="txt">
                  <p>
                    우리 동네 매장들에게 작성한 요청서를 보내 주세요.<br />
                    <span>(요청서 없이 바로 상담도 가능)</span>
                  </p>
                </div>
              </li>
              <li>
                <img src="@/assets/front/images/manual/img_way_03.png" />
                <div class="step"><p>STEP 3</p></div>
                <div class="txt">
                  <p>전송 후에는 채팅방이 개설되며 견적과 상담이 진행됩니다.</p>
                </div>
              </li>
              <li>
                <img src="@/assets/front/images/manual/img_way_04.png" />
                <div class="step"><p>STEP 4</p></div>
                <div class="txt">
                  <p>
                    여러 매장에게 견적을 받아서, 요금과 혜택을 비교해보세요!
                  </p>
                </div>
              </li>
              <li>
                <img src="@/assets/front/images/manual/img_way_05.png" />
                <div class="step"><p>STEP 5</p></div>
                <div class="txt">
                  <p>
                    가장 합리적인 견적을 보낸 매장과 방문(개통)약속을
                    잡아보세요!
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn_sec">
          <ul>
            <li>
              <button @click="handleEstimate">
                <p>휴대폰 요청서 작성</p>
                <span>견적을 빠르고 쉽게 받아보세요!</span>
              </button>
            </li>
            <li>
              <button @click="handleInternetCommerce">
                <p>인터넷 가입 혜택 비교</p>
                <span>전국 매장에서 견적을 보내드립니다!</span>
              </button>
            </li>
            <li>
              <button @click="handleShops">
                <p>렌탈, 악세사리 상담</p>
                <span>매장을 통해 다양한 상담이 가능해요.</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <NewBookModal ref="newBookModal" @close="closeNewBookModal"></NewBookModal>
  </main>
</template>

<script>
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import { mapGetters as commonMapGetters } from '@common/store/modules/common';
import * as commonGetters from '@common/store/modules/common/getters';

import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimateTypes from '@common/store/modules/estimate/types';

import { mapActions as xeronoteMapActions } from '@common/store/modules/xeronote';
import * as xeronoteTypes from '@common/store/modules/xeronote/types';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';

import NewBookModal from '@common/components/chat/modal/NewBookModal';

export default {
  name: 'EstimationForm',
  components: {
    NewBookModal,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleShops() {
      this.$router.push({ path: '/Shops' }).catch(err => {});
    },
    handleEstimate() {
      this.$router.push({ name: 'Estimation.Form' }).catch(err => {});
    },
    handleInternetCommerce() {
      this.$router.push({ name: 'InternetCommerce.List' }).catch(err => {});
    },
    // 사전예약 열기 (hsh)
    openNewBookModal() {
      this.$refs.newBookModal.isOpen = true;
      this.$refs.newBookModal.isSendButton = false;
    },
    closeNewBookModal() {
      this.$refs.newBookModal.isOpen = false;
    },
  },
};
</script>
